import ResearchFiltering from 'src/javascripts/components/ResearchFiltering';
import DistributionChart from 'src/javascripts/components/charts/DistributionChart';

export default class SurveysMetricScoresIndex {

  constructor() {}

  render() {

	  // If an index page 
  	ResearchFiltering();

    // Distribution chart
    if (typeof $('.distributionChart').data('c3-chart') === 'undefined') {
      let $el = $('.distributionChart');
      let $chart = new DistributionChart($el);
      $.when( $chart.getData() )
       .then( data => $chart.render(data) );
    }


 }

}
